import { Context } from '@nuxt/types'
import CODE_KEY from '@/config/code_key'
import { DATA_STORE_FETCHED } from '@/config/event'
import { EventBus } from '@/plugins/event_bus'
import { GlobalWebSocketService } from '@/plugins/websocket'

export default (context: Context) => {
  // console.info('plugins app_init context=', context)
  if (context.route.path !== '/login' && context.route.path !== '/login/') {
    return new Promise(resolve => {
      context.store.dispatch('AuthUserStore/fetch').then(() => {
        context.store.dispatch('DataStore/fetch').then(() => {
          EventBus.emit(DATA_STORE_FETCHED)

          // HACK IME制御のWebSocket接続とタイミングが被っている。テキストフィールドの初期フォーカス処理が存在しない画面では意図的に接続処理を行う必要がある為設定
          if (GlobalWebSocketService.isClosed()) {
            GlobalWebSocketService.connect()
          }
        })
        context.store.dispatch(
          'GlobalSystemParameterStore/fetchAllByCodeKeys',
          [CODE_KEY.REFERENCE_SEARCH_DISPLAY_SETTING.KEY]
        )
        resolve()
      })
    })
  }
}
